import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';

const ProductInfo = ({ sectionHeadings, productDetails }) => (
  <div className="product-info flex-container flex-dir-column">
    <div className="product-info__inner">
      <Heading extraClass="product-info__heading" level={2}>
        {R.path(['collection', 'heading'], sectionHeadings)}
      </Heading>

      <Paragraph
        extraClass="product-info__description"
        testAttribute="product-info-long-description"
      >
        {R.prop('longDescription', productDetails)}
      </Paragraph>
    </div>
  </div>
);

ProductInfo.propTypes = {
  productDetails: PropTypes.shape({
    longDescription: PropTypes.string.isRequired,
  }),
  sectionHeadings: PropTypes.shape({
    relatedProducts: PropTypes.shape({
      heading: PropTypes.string,
    }),
    howToSteps: PropTypes.shape({
      heading: PropTypes.string,
    }),
    retailers: PropTypes.shape({
      heading: PropTypes.string,
    }),
  }),
};

export default ProductInfo;
